import { useState } from "react";
import styled from "styled-components";
import { ToastContainer } from "react-toastify";
import { useOutletContext } from "react-router";

import ModernBanner from "../shopping/component/themes/modern/banner";
import CuteBanner from "../shopping/component/themes/cute/banner";
import SimpleBanner from "../shopping/component/themes/simple/banner";
import ChicBanner from "../shopping/component/themes/chic/banner";
// import DefaultBanner from "../shopping/component/themes/default/banner";

import Intro from "./component/intro";
import History from "./component/history";
import Chart from "./component/chart";
import TabMenu from "../common/tabMenu";
import QuickMenu from "../common/quickMenu";

import { Container } from "../common/styled";
import { findTargetMenuName } from "../common/function/shopping";
import { useMediaQuery } from "react-responsive";
import DetailImage from "./detailImage";

const CustomToast = styled(ToastContainer)`
  z-index: 10000;
  width: "400px";
  font-weight: 600;
  font-size: 16px;
  @media screen and (max-width: 767px) {
    width: 100%;
  }
`;

const Company = () => {
  const isMobile = useMediaQuery({ query: "(max-width:767px)" });
  const { theme, homepageInfo, menus } = useOutletContext();
  const [active, setActive] = useState(0);
  const [isDetailImage, setIsDetailImage] = useState("");
  const tabMenus = ["회사소개", "회사연혁", "조직도"];

  const banners = {
    0: ModernBanner,
    1: ChicBanner,
    2: ModernBanner,
    3: CuteBanner,
    4: SimpleBanner,
  };

  const toggleImageView = async (src) => {
    if (isMobile && src) {
      // const el = document.documentElement;
      // if (el.requestFullscreen) {
      //   await el.requestFullscreen();
      // }
      setIsDetailImage(src);
    } else {
      // if (document.fullscreenElement) {
      //   await document.exitFullscreen();
      // }
      setIsDetailImage(null);
    }
  };

  const renderContent = () => {
    const Banner = banners[theme];
    const activeContent = [
      <Intro />,
      <History toggleImageView={toggleImageView} />,
      <Chart toggleImageView={toggleImageView} />,
    ][active];

    return (
      <>
        {Banner && <Banner />}
        <h3 className="max" style={{ textAlign: theme === 2 ? "left" : "" }}>
          <span>
            {homepageInfo?.cmpnyNo === 15922 ? tabMenus[active] : findTargetMenuName(menus, 0)}
          </span>
        </h3>
        {homepageInfo?.cmpnyNo === 15922 && (
          <TabMenu setActive={setActive} active={active} menus={tabMenus} />
        )}
        {homepageInfo?.cmpnyNo === 15922 ? activeContent : <Intro />}
      </>
    );
  };

  return (
    <Container className={`theme-${theme}`}>
      {isMobile && isDetailImage && (
        <DetailImage isDetailImage={isDetailImage} toggleImageView={toggleImageView} />
      )}
      <QuickMenu />
      <CustomToast
        position="top-center"
        theme="light"
        pauseOnHover
        hideProgressBar={true}
        autoClose={1000}
        closeButton={false}
      />
      {renderContent()}
    </Container>
  );
};

export default Company;
